/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Artcraft_K_SourceInputs */

const en_home_artcraft_k_source = /** @type {(inputs: Home_Artcraft_K_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source code`)
};

/**
* | output |
* | --- |
* | "Source code" |
*
* @param {Home_Artcraft_K_SourceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_artcraft_k_source = /** @type {((inputs?: Home_Artcraft_K_SourceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Artcraft_K_SourceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_artcraft_k_source(inputs)
});
export { home_artcraft_k_source as "home.artcraft.k_source" }